import { useQuery } from "@tanstack/react-query";

import { asQuery } from "simplydo/core/api";
import SearchParams from "simplydo/core/searchParams";

import api from "api";

export const useMe = () => {
  const params = new SearchParams(window.location.search);
  const utmReferrer = params.get("utm-link");
  const { data: me } = useQuery({
    queryKey: ["users", "me"],
    queryFn: asQuery(api.users.me, { params: [utmReferrer] })!,
  });

  return me;
};
